import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
import '../../assets/scripts/number.js'

$("header .nav ul li").eq(0).addClass("active");

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	autoplay: {
        delay: 5000,
        disableOnInteraction: false,
	},
	speed:1000,
	loop:true,//必须
}); 

$(".product-list .content").eq(0).addClass('active');
$(".product-nav ul li").eq(0).addClass('active');
$(".product-nav ul li").click(function() {
  let index = $(this).index();
  $(this).addClass('active').siblings().removeClass('active');
  $(".product-list .content").eq(index).addClass('active').siblings().removeClass('active');
})

// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".section2").offset().top  && istrue) {
	$(".timer").each(count);
	function count(a) {
		var b = $(this);
		a = $.extend({},
		a || {},
		b.data("countToOptions") || {});
		b.countTo(a)
	};
	istrue = false;
};

$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".section2").offset().top && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a) 
        };
        istrue = false;
    };
    
})

var swiper = new Swiper(".section6 .swiper", {
    slidesPerView: 4,
    slidesPerGroup: 4,
    spaceBetween: '1.5%',
    breakpoints: {
        1024: {  //当屏幕宽度小于等于1280
            slidesPerView: 4,
            slidesPerGroup: 4,
            spaceBetween: '1.5%',
        },
        320: {  //当屏幕宽度小于等于320
            slidesPerView: 2,
            slidesPerGroup: 2,
            spaceBetween: 10,
        }
    }, 
    navigation: {
        nextEl: ".section6 .swiper-button-next",
        prevEl: ".section6 .swiper-button-prev",
    },
});